import { IconButton } from "@chakra-ui/react";
import React, { useState } from "react";
import { RiDeleteBinLine, RiFileEditLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import { openPlaylistModel } from "../../../modules/admin-modules/models/Actions";
import { deletePlaylistRequest } from "../../../modules/admin-modules/playlists/Actions";

const PlaylistsTable = ({ setAdd, setSelectedData }) => {
  const playlists = useSelector((state) => state.playlists.playlists);
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.playlists.isLoading);
  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [selected, setSelected] = useState({
    id: "",
  });
  const viewData = (data) => {
    setSelectedData(data);
    setSelected(data);
  };
  const Data = playlists?.map((data) => {
    return {
      ...data,
      id: data?.id,
      title: data?.name,
      tag: data?.question_tag?.name,
      edit: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiFileEditLine />}
          onClick={() => {
            setAdd(false);
            dispatch(openPlaylistModel());
          }}
        />
      ),

      delete: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiDeleteBinLine color="red" />}
          onClick={() => dispatch(deletePlaylistRequest(data?.id))}
        />
      ),
    };
  });
  const columns = [
    {
      Header: " قائمة التشغيل",
      accessor: "title",
    },
    {
      Header: "  العلامة",
      accessor: "tag",
    },
    {
      Header: "تعديل",
      accessor: "edit",
    },
    {
      Header: "حذف",
      accessor: "delete",
    },
  ];

  return (
    <CTable
      selectedData={viewData}
      Columns={columns}
      Data={Data}
      path={"openModel"}
      Actions
      Title={``}
      subTitle=""
      btnTitle=""
      placeHolder=""
      noSearchBar={true}
      noFilter={true}
      footerBtnTitle
      filterList
      addButton
      addButtonTitle=""
      setPage={setPage}
      setPerPage={setPerPage}
      currentpage={pageNumber}
      setPageNumber={setPageNumber}
      noSecondSearchBar={true}
      isLoading={isLoading}
      perPage={size}
      totalPage={Math.ceil(playlists?.length / 10)}
    />
  );
};

export default PlaylistsTable;
